import { render, staticRenderFns } from "./TaskDepartmentCRUD.vue?vue&type=template&id=e131bcbc"
import script from "./TaskDepartmentCRUD.vue?vue&type=script&lang=js"
export * from "./TaskDepartmentCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports